import { getProxyUrl } from '@proxies/index'
import { useEffect, useState } from 'react'
type BaseDoorWindowtextures = { bisagras?: string[]; manos?: string[] }
type DoorWindowtextures = BaseDoorWindowtextures & {
  combinaciones?: BaseDoorWindowtextures & { idUnidades: number }[]
  readonly isFirst?: boolean
}

export function useHoleModal(id: number) {
  const [state, setState] = useState<DoorWindowtextures>({
    bisagras: [],
    manos: [],
    combinaciones: [],
    isFirst: true,
  })
  useEffect(() => {
    const params = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept-Language': 'ES',
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    }
    if (state.isFirst) {
      fetch(getProxyUrl(`api/Unidades/getinfopuertaventa/${id}`), params)
        .then((data) => {
          if (data.ok) {
            return data.json()
          }
        })
        .then((jsondat) => {
          const jsondata = jsondat as unknown as Omit<DoorWindowtextures, 'isFirst'>
          const isIzqInt = jsondata.combinaciones?.find(
            ({ mano, bisagra }) =>
              (mano && mano === 'Izquierda' && bisagra && bisagra === 'Interior') ||
              (!mano && bisagra === 'Interior') ||
              (!bisagra && mano === 'Izquierda'),
          )
          setState({
            bisagras: isIzqInt?.bisagra,
            manos: isIzqInt?.mano,
            combinaciones: jsondata.combinaciones,
          })
        })
    }
  }, [id, state.isFirst])

  return state as Omit<DoorWindowtextures, 'isFirst'>
}
